/**
 * Keeps the price shown inside the "Add to cart | $X" button in step with the
 * Recharge purchase option the customer has chosen.
 *
 * The Recharge widget renders in its own shadow root and doesn't touch the
 * theme's price element — it only writes the chosen plan id into the hidden
 * `selling_plan` input in the product form. The button therefore kept showing
 * the one-time price after "Subscribe & save" was selected.
 *
 * Prices come from the widget's own config (window.SubscriptionWidgetConfig
 * .formattedPrices), keyed by variant id and then by selling plan id, so the
 * figures always match what the widget itself displays — including currency
 * formatting and any market-specific pricing.
 */
(function () {
  'use strict';

  function priceFor(variantId, sellingPlanId) {
    var config = window.SubscriptionWidgetConfig;
    var prices = config && config.formattedPrices;
    var record = prices && prices[variantId];

    if (!record) return null;

    if (sellingPlanId && record.sellingPlans && record.sellingPlans[sellingPlanId]) {
      return record.sellingPlans[sellingPlanId].price || null;
    }

    // No plan selected — one-time purchase.
    return record.unit || null;
  }

  function formOf(el) {
    var id = el.getAttribute('form');
    return (id && document.forms[id]) || el.closest('form');
  }

  function sync() {
    document.querySelectorAll('product-buy-price').forEach(function (el) {
      var form = formOf(el);
      if (!form) return;

      var variantInput = form.querySelector('input[name="id"]');
      var planInput = form.querySelector('[name="selling_plan"]');
      if (!variantInput) return;

      var price = priceFor(variantInput.value, planInput && planInput.value);
      if (price && el.textContent.trim() !== price) el.textContent = price;
    });
  }

  var queued = false;
  function queueSync() {
    if (queued) return;
    queued = true;
    // The widget writes the input during its own event handling, so read on the
    // next frame rather than mid-dispatch.
    requestAnimationFrame(function () {
      queued = false;
      sync();
    });
  }

  // The widget's input events are retargeted to its host element, so filtering on
  // the original input isn't reliable — listen broadly and let sync() no-op.
  document.addEventListener('input', queueSync, true);
  document.addEventListener('change', queueSync, true);

  // Changing variant re-renders the buy-buttons block from the section rendering
  // API, which replaces the price element with a freshly rendered one-time price.
  document.addEventListener('variant:change', queueSync);
  document.addEventListener('bundle:change', queueSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueSync);
  } else {
    queueSync();
  }
})();
